<div class="select-language-holder {{ documentDirection }}">
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
    <!-- <select class="obf-select" [(ngModel)]="choosenLanguage"
        *ngIf="languages$ | async as languages">
        <option *ngFor="let lang of languages" [ngValue]="choosenLanguage">{{ lang.code }}</option>
    </select> -->
    
    <span class="language-indicator" (click)="expand = !expand">
        <i *ngIf="currentLanguageFlagUrl" [style.background-image]="'url(' + currentLanguageFlagUrl + ')'"></i>
        <span>{{ choosenLanguageTitle }}</span>
        <span class="iconarrow" [ngClass]="{'revert': expand}"></span>
    </span>
    <ul class="languages-list" [ngClass]="{'show': expand}" *ngIf="languages$ | async as languages">
        <li *ngFor="let lang of languages" (click)="selectLanguage(lang); expand = !expand">
            <i *ngIf="lang.icon_url" [style.background-image]="'url(' + lang.icon_url + ')'"></i>
            {{ lang.title }}
        </li>
    </ul>
</div>
<ng-container *ngIf="isLanguageFieldDirty">
    <span class="submit-btn" (click)="submitLanguage()" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.submit_select_language_button ? moduleAuthTexts.submit_select_language_button : 'Save' }}</span>
</ng-container>